import { render } from "./ImageBase64Field.vue?vue&type=template&id=1f872496&ts=true&lang=pug"
import script from "./ImageBase64Field.vue?vue&type=script&lang=ts"
export * from "./ImageBase64Field.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__